module.exports = __webpack_public_path__ + "static/img-laptop-zone-and-weight@2x.80f0f826.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-laptop-zone-and-weight@2x.png
// module id = 50
// module chunks = 168707334958949